import { render, staticRenderFns } from "./dropbox-wrapper.vue?vue&type=template&id=c47f8b0e&"
import script from "./dropbox-wrapper.vue?vue&type=script&lang=js&"
export * from "./dropbox-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports